export const SET_SIMULATION = 'SET_SIMULATION';
export const SET_ACCOMMODATION_ID = 'SET_ACCOMMODATION_ID';
export const SET_INIT_DATE = 'SET_INIT_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const SET_TOTAL_DAYS = 'SET_TOTAL_DAYS';
export const SET_GUESTS = 'SET_GUESTS';
export const SET_AVAILABLE = 'SET_AVAILABLE';

